import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Blog from "@/components/Blog";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => (
  <div className="App bg-[#FBF9F6] text-[#1A0010]">
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Blog />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
